import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

export const ClearUserNameEntryButton = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="p-1 rounded hover:bg-neutral-200 focus:outline-none"
    tabIndex={-1}
    aria-label={
      <FormattedMessage id="username.clear" defaultMessage="Clear username" description="Clear button text label" />
    }
  >
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" stroke="currentColor" strokeWidth={2} className="h-4 w-4 text-neutral-500">
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l8 8M6 14L14 6" />
    </svg>
  </button>
);

ClearUserNameEntryButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};